'use client';

import { createContext, useContext } from 'react';

import type { UserType } from '@app-types/user';

export type StableSessionContextType = { user: UserType | undefined };

export const StableSessionContext = createContext<StableSessionContextType>({ user: undefined });

export function useStableSession(): StableSessionContextType {
    return useContext(StableSessionContext);
}
